import React from 'react';
import C18Anchor00 from './C18Anchor00'
import C18Select01 from './C18Select01'
import C18Button00 from './C18Button00'
import C18SubMenuHeader00 from './C18SubMenuHeader00'
import {loadZonesInfo,getZoneInfo,setSiteZoneTypes,loadSiteData,loadGatewaysInfo,
  saveTable,getSiteName,getZoneName,loadSensorsInfo,acctFeature,} from './C18utils'
import {dbVals,sendArray} from '../../components/utils/http';
import {pInd} from '../../components/utils/paramIds'
import {wsTrans,getParamId2,getDbId,getDbVal,initSensorIds,sensorIds,objEq,
  makeNum,valInp,
} from '../utils/utils'
import {cl,globs,getTime,constant,getRandomString} from '../../components/utils/utils';

var c={
  MBTY_COIL:0x00,// bits 0,1
  MBTY_DISC:0x01,
  MBTY_HOLD:0x02,
  MBTY_INP:0x03,
  MBTY_MASK:0x03,
  MBTY_SHIFT:0,
  STCO_STATUS:0x00,// bit 2,3
  STCO_OUTPUT:0x04,
  STCO_CONFIG:0x08,
  STCO_MASK:0x0C,
  STCO_SHIFT:2,
  ANDI_ANA:0x00,// bit4
  ANDI_DIG:0x10,
  ANDI_MASK:0x10,
  ANDI_SHIFT:4,
  PRIO_0:0x00,// bits 4,5 - highest priority
  PRIO_1:0x20,
  PRIO_2:0x40,
  PRIO_3:0x60,
  PRIO_MASK:0x60,
  PRIO_SHIFT:5,
  DILN_2:0x0000,
  DILN_4:0x0080,
  DILN_8:0x0100,
  DILN_16:0X0180,
  DILN_MASK:0x0180,
  DILN_SHIFT:7,
  RESP_MASK:0xFE00,
  RESP_SHIFT:9,
  GMTY_MAX:0x0F,// these are in gmbType
  GMTY_SHIFT:0,
  GMTY_RECN_MASK:0xF0,
  GMTY_RECN_SHIFT:4,
  MB_RD_COIL:1,
  MB_RD_DISC:2,
  MB_RD_HOLD:3,
  MB_RD_INP:4,
  MB_WR_COIL:5,
  MB_WR_HOLD:6,
  MB_WR_COILS:15,
  MB_WR_HOLDS:16,

  GMB_DATA_TYPE_NONE:0,// dataTypes
  GMB_DATA_TYPE_GENERAL:1,// dataTypes
  GMB_DATA_TYPE_TEMP:2,
  GMB_DATA_TYPE_HUM:3,
  GMB_DATA_TYPE_CO2:4,
  GMB_DATA_TYPE_LIGHT:5,
  GMB_DATA_TYPE_PRESS:6,
  GMB_DATA_TYPE_MOIST:7,
  GMB_DATA_TYPE_DOXY:8,
  GMB_DATA_TYPE_DIST:9,
  GMB_DATA_TYPE_FLOW:10,
  GMB_DATA_TYPE_WSPD:11,
  GMB_DATA_TYPE_WDIR:12,
  GMB_DATA_TYPE_PH:13,
  GMB_DATA_TYPE_EC:14,
  GMB_DATA_TYPE_MASS:15,
  GMB_DATA_TYPE_VOLUME:16,

  STYPE_NONE:0,
  STYPE_SENSOR:1,
  STYPE_EQ_POS:2,
  STYPE_SETPOINT:3,
  STYPE_STAGE:4,
  STYPE_AUX_VAR:5,
  STYPE_AUX_PVAR:6,
  STYPE_AUX_ALARM:7,
  STYPE_NUMBER:8,

  SFORMAT_UINT16:0,
  SFORMAT_INT16:1,
  SFORMAT_UINT32:2,
  SFORMAT_INT32:3,
  SFORMAT_FLOAT:4,
  SFORMAT_FLOAT3210:4,
  SFORMAT_FLOAT0123:5,
  SFORMAT_FLOAT1032:6,
  SFORMAT_FLOAT2301:7,
}

var xBoardIds=["numOutId","chIndex","typeId","addIndex","numInps",
  "startInp","mbPort",]
var xbMult=pInd[1900].config_expansion_boards[2]


class MbBuf{

  #crc16=(buffer,len)=>{
    var crc = 0xFFFF;
    var odd;
    for (var i = 0; i < len; i++) {
      crc = crc ^ buffer[i];
      for (var j = 0; j < 8; j++) {
        odd = crc & 0x0001;
        crc = crc >> 1;
        if (odd) {
            crc = crc ^ 0xA001;
        }
      }
    }
    return crc;
  }

  constructor(size){
    this.buf=new Uint8Array(size)
    this.ind=0
  }

  addByte(bVal){
    this.buf[this.ind++]=bVal
  }

  addReg(regVal){
    this.buf[this.ind++]=(regVal>>8)&0xFF
    this.buf[this.ind++]=regVal&0xFF
  }

//   addRegSpec(regVal,regSpc){
//     this.dmrWriteSpec(this,regSpc,regVal)
// //     this.buf[this.ind++]=(regVal>>8)&0xFF
// //     this.buf[this.ind++]=regVal&0xFF
//   }

  getReg(ofs){
    return (this.buf[ofs]<<8)+this.buf[ofs+1]
  }

  addCRC(){
    let crc=this.#crc16(this.buf,this.ind)
    cl(crc)
    this.buf[this.ind++]=crc&0xFF
    this.buf[this.ind++]=(crc>>8)&0xFF
  }

  getBuf(){
    return Array.from(this.buf)
  }

  setBuf(arr){
    this.buf=new Uint8Array(arr)
//     cl(this.buf)
  }

  showBuf(){
    let res=Array.from(this.buf).map(b=>{return ("00"+b.toString(16)).slice(-2)})
    cl(res.join(" "))
  }
}

class C18ModbusGP01 extends React.Component{
  constructor(props) {
    super(props);
    // cl(props)
    this.state={
      loaded:false,
      devType:0,
      mbAddr:"",
      devType:"",
      regVals:[],
      pageType:"config",
      selDevice:-1,
      selStream:-1,
      newTypeId:1,
      newRegId:1,
      cfgReg:0,
      mbPort:4,
//       type:0,
//       strPort:0,
      dataTypes:[
      "None",
      "General",
      "Temperature",
      "Humidity",
      "CO2",
      "Light",
      "Pressure",
      "Moisture",
      "Dissolved Oxygen",
      "Distance",
      "Flow Rate",
      "Wind Speed",
      "Wind Direction",
      "pH",
      "EC",
      "Mass",
      "Volume",
    ],
      devices:[
        {
          type:"xy-md02",
          port:0,
          addr:1,
        }
      ],
      contDevTypes:{
        "xy-md02":"xymd",
        "xy-md02b":"xymb",
      },
      deviceTypes:{// used to send to Pearl
        "xy-md02":{
          name:"XY-MD02",
          registers:[
            {
              name:"Temperature",
              addr:0x0001,
              ofs:26829,
              slope:17432,
              flags0:c.MBTY_INP|c.STCO_STATUS|c.ANDI_ANA|c.PRIO_0,
              dataType:c.GMB_DATA_TYPE_TEMP,
            },
            {
              name:"Humidity",
              addr:0x0002,
              ofs:0,
              slope:1.0,
              flags0:c.MBTY_INP|c.STCO_STATUS|c.ANDI_ANA|c.PRIO_0,
              dataType:c.GMB_DATA_TYPE_HUM,
            },
            {
              name:"TempCal",
              addr:0x0103,
              ofs:0,
              slope:1.0,
              flags0:c.MBTY_HOLD|c.STCO_OUTPUT|c.ANDI_DIG|c.PRIO_0|c.DILN_8,
              dataType:c.GMB_DATA_TYPE_TEMP,
            },
          ]
        },
        "xy-md02b":{
          name:"XY-MD02b",
          registers:[
            {
              name:"Temperature",
              addr:0x0001,
              ofs:0,
              slope:1.0,
              flags0:c.MBTY_INP|c.STCO_STATUS|c.ANDI_ANA|c.PRIO_0,
              dataType:c.GMB_DATA_TYPE_TEMP,
            },
            {
              name:"Humidity",
              addr:0x0002,
              ofs:0,
              slope:1.0,
              flags0:c.MBTY_INP|c.STCO_STATUS|c.ANDI_ANA|c.PRIO_0,
              dataType:c.GMB_DATA_TYPE_HUM,
            },
            {
              name:"TempCal",
              addr:0x0103,
              ofs:0,
              slope:1.0,
              flags0:c.MBTY_HOLD|c.STCO_OUTPUT|c.ANDI_DIG|c.PRIO_0|c.DILN_8,
              dataType:c.GMB_DATA_TYPE_TEMP,
            },
          ]
        }
      }
    }
    this.subscribe_savePageEvent=globs.events.subscribe("savePageEvent",this.saveModbus)
    this.streamPorts=[
      {v:0,t:"1"},
      {v:1,t:"2"},
      {v:2,t:"3"},
      {v:3,t:"4"},
    ]
    this.streamPeriods=[
      {v:5,t:"5 Secs"},
      {v:15,t:"15 Secs"},
      {v:60,t:"1 Min"},
      {v:300,t:"5 Min"},
      {v:900,t:"15 Min"},
      {v:3600,t:"1 Hr"},
      {v:18000,t:"5 Hr"},
      {v:54000,t:"15 Hr"},
    ]
//     this.streamConvs=[
//       {v:0,t:"x1"},
//       {v:1,t:"x10"},
//       {v:2,t:"x100"},
//       {v:10,t:"Float 3210 (2 Reg)"},
//       {v:11,t:"Float 1032 (2 Reg)"},
//       {v:12,t:"Float 0123 (2 Reg)"},
//       {v:13,t:"Float 2301 (2 Reg)"},
//     ]
    this.streamFuncs=[
      {v:5,t:"Write Single Coil"},
      {v:6,t:"Write Single Holding Register"},
//       {v:15,t:"Write Multiple Coils"},
//       {v:16,t:"Write Multiple Holding Registers"},
    ]

    this.streamDataTypes=[// "type"
      {v:0,t:"Uint 16"},
      {v:1,t:"Int 16"},
      {v:2,t:"Uint 32 (2 Regs)"},
      {v:3,t:"Int 32 (2 Regs)"},
      {v:4,t:"Float (2 Regs)"},
    ]

    this.streamByteOrder16=[// "format"
      {v:0,t:"Big Endian"},
      {v:1,t:"Little Endian"},
    ]

    this.streamByteOrder32=[// "format"
      {v:0,t:"Bytes 3210 (2 Regs)"},
      {v:1,t:"Bytes 0123 (2 Regs)"},
      {v:2,t:"Bytes 1032 (2 Regs)"},
      {v:3,t:"Bytes 2301 (2 Regs)"},
    ]

    this.streamFields=["port","addr","reg","period","mbFunc","type","format",
      "dataToSend","id","slope","ofs","rsvd1","rsvd2","rsvd3","name"]
  }

  devTypes={// used for passthru
    "xy-md02":{
      name:"XY-MD02",
      regs:[
        {
          name:"Temperature",
          addr:0x0001,
          type:c.MBTY_INP|c.STCO_STATUS|c.ANDI_ANA|c.PRIO_0
        },
        {
          name:"Humidity",
          addr:0x0002,
          type:c.MBTY_INP|c.STCO_STATUS|c.ANDI_ANA|c.PRIO_0
        },
        {
          name:"Address",
          addr:0x0101,
          type:c.MBTY_HOLD|c.STCO_CONFIG
        },
        {
          name:"Baud Rate",
          addr:0x0102,
          type:c.MBTY_HOLD|c.STCO_CONFIG
        },
        {
          name:"Temp Cal",
          addr:0x0103,
          type:c.MBTY_HOLD|c.STCO_CONFIG|c.ANDI_DIG|c.DILN_8
        },
        {
          name:"Hum Cal",
          addr:0x0104,
          type:c.MBTY_HOLD|c.STCO_CONFIG
        },
      ]

    }
  }

  componentDidMount(){
    this.setBreadCrumbs()
    this.loadInfo()
  }

  setBreadCrumbs=()=>{
//     cl(this.props.parms)
    let p=this.props.parms
    let siteName=getSiteName(p.site)
    let zoneName=getZoneName(p.zone)
//     cl(siteName, zoneName)
    if(p){
      p.onChange(
        {
          cmd: "breadcrumbs",
          data:
            {breadcrumbs: [
              {t:"Sites", url:"/usa/c18/sites"},
              {t:siteName, url:`/usa/c18/sites/${this.props.parms.site}`},
              {t:zoneName, url:`/usa/c18/sites/${this.props.parms.site}/zones/${this.props.parms.zone}`},
//               {t:"iDoser", url:`/usa/c18/idoser/nutrients`},
              {t:"Expansion", url:`/usa/c18/sites/${p.site}/zones/${p.zone}/pearl/expansion`},
            ]},
        },
      )
    }
  }

  getCurrentDeviceTypes=()=>{
    let pa=this.props.parms
    this.zone=globs.zonesInfo.info
      .filter(z=>{return z.zoneId==pa.zone})[0]
    if(!this.zone){return []}
    this.gateway=globs.gatewaysInfo.info
      .filter(g=>{return g.gatewayId==this.zone.gatewayId})[0]
    if(!this.gateway){return []}
//     cl(this.gateway)
    return this.gateway.gmbDeviceTypes||[]
  }

//   getCurrentStreams=()=>{
//     let pa=this.props.parms
//     this.zone=globs.zonesInfo.info
//       .filter(z=>{return z.zoneId==pa.zone})[0]
//     if(!this.zone){return []}
//     this.gateway=globs.gatewaysInfo.info
//       .filter(g=>{return g.gatewayId==this.zone.gatewayId})[0]
//     if(!this.gateway){return []}
//     //     cl(this.gateway)
//     return this.gateway.gmbStreams||[]
//   }

  getCloudIds=()=>{
    let ceb="configuration_expansion_boards"
    let xca="pearl_xboard_cfg_anx"
    let gmr="pearl_gmb_registers"
    let gmt="pearl_gmb_types"
    let gwType=1900
    this.ids={
      numOutId:getParamId2(gwType,ceb,"numOutputs"),
      chIndex:getParamId2(gwType,ceb,"startChannelIndex"),// starting output
      addIndex:getParamId2(gwType,ceb,"address"),
      typeId:getParamId2(gwType,ceb,"boardType"),
      numInps:getParamId2(gwType,ceb,"numInputs"),
      startInp:getParamId2(gwType,ceb,"startInput"),
      mbPort:getParamId2(gwType,ceb,"modbusPort"),
      uniqueId1:getParamId2(gwType,xca,"uniqueId1"),
      zoneUid:getParamId2(gwType,xca,"zoneUid"),

      gmrRegisterId:getParamId2(gwType,gmr,"registerId"),
//       gmrRegisterSpc:getParamId2(gwType,gmr,"registerSpc"),
//       gmrRegisterCnt:getParamId2(gwType,gmr,"registerCnt"),
      gmrCalOfs:getParamId2(gwType,gmr,"cal_ofs"),
      gmrCalSlope:getParamId2(gwType,gmr,"cal_slope"),
      gmrType:getParamId2(gwType,gmr,"gmbType"),
      gmrDataType:getParamId2(gwType,gmr,"dataType"),
      gmrFlags:getParamId2(gwType,gmr,"flags0"),
      gmtName:getParamId2(gwType,gmt,"sName"),
//       zoneUidName:getParamId2(gwType,xca,"zoneUidName"),
//       statusId:getParamId2(gwType,seb,"boardStatus"),

    }
  }

  loadXBoards=(zInd)=>{
    let id=this.ids.typeId
    let ch=dbVals.z[zInd][240]
    let xBoards=Array(constant.CONT_NUM_XBOARDS)
    for(let i=0;i<constant.CONT_NUM_XBOARDS;i++){
      let type=ch[id+xbMult*i]
      if(type!=constant.MB_SLAVE_TYPE_NONE){
        xBoards[i]={typeId:type,}
        xBoardIds.forEach(id=>{
          xBoards[i][id]=+ch[this.ids[id]+xbMult*i]
        })
      }
    }
//     cl(xBoards)
    return xBoards
  }

  getGmbDevices=(xBoards,instDeviceTypes)=>{
//     cl(xBoards)
//     cl(instDeviceTypes)
    let devices=[]
    xBoards.forEach(xb=>{
      let gmbType=xb.typeId-constant.MB_GMB_0// local devType
      if(xb&&(gmbType>=0)&&(gmbType<16)){// one of ours
//         cl("push")
        devices.push({
          type:instDeviceTypes[gmbType],
          port:xb.mbPort+1,
          addr:xb.addIndex,
        })
      }
    })
    return devices
  }

  cleanGmbConfig=(cfg)=>{// eliminate None dataType
    Object.keys(cfg).forEach(k=>{
      let dev=cfg[k]
      dev.registers.forEach(r=>{
        if(!+r.dataType){r.dataType=1}
      })
    })
  }

//   getMappedGenS=(zInd)=>{
//     let gs=[...Array(128).keys()]
//       .map(k=>{return {
//         m:+getDbVal("pearl_gen_sens_conf","mapping",zInd,240,k),
//         k:k,
//       }})
//       .filter(k=>k.m)
//     cl(gs) // {m: 29, k: 2}
//     return gs
//   }
//
//   getMappedSensors=(zInd)=>{
//     let ms=[...Array(constant.TOTAL_SENSORS).keys()]
//     .map(k=>{return {
//       m:+getDbVal("pearl_sensor_config","mapping",zInd,240,k),
//          k:k,
//     }})
//     .filter(k=>k.m)
//     cl(ms) // {m: 29, k: 2}
//     return ms
//   }

  getMapped=(zInd,len,tab,col,ch)=>{
    let mapped=[...Array(len).keys()]
    .map(k=>{
      if(ch>=0){
        return{
          m:+getDbVal(tab,col,zInd,ch,k),
          k:k,
        }
      }else{
        return{
          m:+getDbVal(tab,col,zInd,k,0),
          k:k,
        }
      }
    })
    .filter(k=>k.m)
//     cl(mapped) // {m: 29, k: 2}
    return mapped.map(v=>v.k)// returns just the ids
  }

//   getMappedEq=(zInd)=>{
//     return this.getMapped(zInd,128,"channels_configuration","channelType",-1)
// //     let ms=[...Array(constant.TOTAL_SENSORS).keys()]
// //     .map(k=>{return {
// //       m:+getDbVal("pearl_sensor_config","mapping",zInd,240,k),
// //          k:k,
// //     }})
// //     .filter(k=>k.m)
// //     cl(ms) // {m: 29, k: 2}
// //     return ms
//
//   }

  getStrEquip=(zInd)=>{
    let chans=this.getMapped(zInd,128,"channels_configuration","channelType",-1)
//     cl(chans)
    return chans.map(c=>{// return opts for eq
      return{
        v:c,
        t:getDbVal("channels_configuration","channelName",zInd,c,0),
      }
    })
  }

  getAuxVars=(zInd,cnt,tab,col)=>{
    let auxVars=this.getMapped(zInd,cnt,tab,"allowGraphing",240)
//     cl(auxVars)
    return auxVars.map(a=>{// return opts for eq
      return{
        v:a,
        t:getDbVal(tab,col,zInd,240,a),
      }
    })
  }

  getStrSensors=(zInd)=>{
//       m:+getDbVal("pearl_sensor_config","mapping",zInd,240,k),
    // get the mapped sensor Ids
    let sensors=this.getMapped(zInd,constant.TOTAL_SENSORS,
      "pearl_sensor_config","mapping",240)
    let gSense=this.getMapped(zInd,constant.TOTAL_SENSORS,
      "pearl_gen_sens_conf","mapping",240)
    sensors=sensors.concat(gSense.map(g=>g+constant.TOTAL_SENSORS))// sensor indexes
    // get our general sensor info
    initSensorIds(zInd)
    // get custom sensor names
    let pa=this.props.parms
    let zone=globs.zonesInfo.info.filter(z=>{
      return z.zoneId==pa.zone
    })[0]

    let sn0=globs.sensorsInfo.info.filter(s=>{
      return /*(s.zoneId==zone.zoneId)&&*/(s.siteId==zone.siteId)
    })
//     cl(sn0)


    let sensorNames=globs.sensorsInfo.info.filter(s=>{
//       cl(s)
      return (s.zoneId==zone.zoneId)&&(s.siteId==zone.siteId)
    })[0]?.sensorNames||[]
    // organize by sensorInd, get sensorId, look up custom name
    let s2={}// sensor info indexed by sensor index, 0-76
    Object.keys(sensorIds)
    // get those with lcIndex, and *not* 800s
    .filter(k=>{
      return (sensorIds[k].lcIndex!=null)&&(k.slice(-3)!="800")
    })
    // save the important info, indexed by sensor index
    .forEach(k=>{
      let s=sensorIds[k]
      s2[s.lcIndex]={k:k,name:s.name,name2:s.name2}
    })
//     cl(s2)// indexed by sensor index
    let sensorOpts=sensors.map(ind=>{
      let s=s2[ind]
      let name=sensorNames[s.k]
      return{
        v:ind,
        t:(name)?name:s.name
      }
    })
    return sensorOpts
  }



  loadStreamInfo=()=>{
    let st=this.state
//     let type=st.streams?.[st.selStream]?.type||"sensor"
    let pa=this.props.parms
    let zone=globs.zonesInfo.info.filter(z=>{
      return z.zoneId==pa.zone
    })[0]
//     cl(zone)
    let zInd=zone.siteZoneIndex
    this.streamIds={
      [c.STYPE_SENSOR]:this.getStrSensors(zInd),
      [c.STYPE_EQ_POS]:this.getStrEquip(zInd),
      [c.STYPE_SETPOINT]:[
        {v:0,t:"Heat Setpoint"},
        {v:1,t:"Cool Setpoint"},
        {v:2,t:"Hum Setpoint"},
        {v:3,t:"DeHum Setpoint"},
      ],
      [c.STYPE_STAGE]:[
        {v:0,t:"Temperature (0-12)"},
        {v:1,t:"Humidity (0-3)"}
      ],
      [c.STYPE_AUX_VAR]:this.getAuxVars(zInd,64,"config_aux_variables","variableName"),
      [c.STYPE_AUX_PVAR]:this.getAuxVars(zInd,32,"config_aux_persistent_variables","variableName"),
      [c.STYPE_AUX_ALARM]:this.getAuxVars(zInd,32,"config_aux_alarms","alarmName"),
    }
//     cl(this.streamIds)
//     let chans=this.getStrSensors(zInd)
//     cl(chans)
//     this.streamIds=chans
    return

//     initSensorIds(zInd)
//     cl(sensorIds)
//     let s2={}
//     Object.keys(sensorIds)
//     .filter(k=>{
//       return (sensorIds[k].lcIndex!=null)&&(k.slice(-3)!="800")
//     })
//     .forEach(k=>{
//       let s=sensorIds[k]
//       s2[s.lcIndex]={k:k,name:s.name,name2:s.name2}
//     })
//     cl(s2)// indexed by sensor Id
//
//
//     let mgs=this.getMappedGenS(zInd)
//     let ms=this.getMappedSensors(zInd)
//     cl(mgs)
//     let sensors=mgs.map(g=>{return `e0gn${g.k}`})
//     cl(sensors)
//     let sensors3=sensors.concat(ms.map(s=>{
//       return s2[s.k].k
//     }))
//     cl(sensors3)
//     let sensorNames=globs.sensorsInfo.info.filter(s=>{
//       return (s.zoneId==zone.zoneId)&&(s.siteId==zone.siteId)
//     })[0].sensorNames
//     let sensorOpts=sensors3.map(s=>{
//       let name=(sensorNames[s])?sensorNames[s]:sensorIds[s].name
// //       cl(name)
//       return{v:s,t:name}
//     })
//
//     cl(sensorOpts)
//     this.streamIds=sensorOpts
// //     let sensors=await loadSensorsInfo()
// //     cl(globs.sensorsInfo.info)

  }

  loadInfo=async()=>{
    let st=this.state
    let pa=this.props.parms
//     cl(st)
//     cl(pa)
    let devType=Object.keys(st.deviceTypes)[0]
    this.getCloudIds()
//     let zone=globs.userData.session.
    this.zone=globs.zonesInfo.info.filter(z=>{
      return z.zoneId==pa.zone
    })[0]
//     cl(this.zone)

//     cl(zone)
    let xBoards=this.loadXBoards(this.zone.siteZoneIndex)
//     cl(xBoards)
//     cl(this.ids)
    await loadGatewaysInfo()
    await loadSensorsInfo()
//     cl(globs.sensorsInfo)
    this.loadStreamInfo()
    //     cl(this.props)
    let z=globs.zonesInfo.info.filter(z=>{return z.zoneId==pa.zone})[0]
    this.zInd=z.siteZoneIndex
    let streams=this.loadStreams()
//     cl(globs.gatewaysInfo)
    let gw=globs.gatewaysInfo.info.filter(gw=>{return gw.gatewayId==z.gatewayId})[0]
//     cl(gw.gmbDeviceTypes)
    let instDeviceTypes=this.getCurrentDeviceTypes()
    cl()
//     let streams=this.getCurrentStreams()
    let devices=this.getGmbDevices(xBoards,instDeviceTypes)
//     cl(devices)
    let query={type:"gmbDevTypes"}
    let res=((await wsTrans("usa", {cmd: "cRest", uri: "/s/gmbConfig",
      method: "retrieve", sessionId: globs.userData.session.sessionId,
      body: query}))?.data||[])[0]?.vals
//     cl(res)
    this.cleanGmbConfig(res||{})// remove dataType "none"
//     cl(res)

    if(!res){res=st.deviceTypes}
    this.setState({loaded:true,devType:devType,clientId:gw?.clientId,
      instDeviceTypes:instDeviceTypes,
      devices:devices,
      xBoards:xBoards,
      initXBoards:xBoards.slice(0),
      cfgType:Object.keys(st.deviceTypes)[0],
      deviceTypes:res,
      streams:streams,
    })
  }

  getDeviceTypes=()=>{// scans devices to get *new* local devTypes
    let st=this.state
    let devTypes0={}
    st.devices.forEach(d=>{devTypes0[d.type]=1})
    return Object.keys(devTypes0).sort()
  }

  updateUniqueDeviceTypes=async()=>{
    let st=this.state
//     let devTypes0={}
//     st.devices.forEach(d=>{devTypes0[d.type]=1})
//     let devTypes=Object.keys(devTypes0).sort()
    let devTypes=this.getDeviceTypes()
//     cl(devTypes)
//     cl(st.instDeviceTypes)
    let isChange=devTypes.length!=st.instDeviceTypes.length
    devTypes.forEach((t,i)=>{
//       cl(t,st.instDeviceTypes)
      isChange|=(t!=st.instDeviceTypes[i])
    })

    if(isChange){
      this.gateway.gmbDeviceTypes=devTypes
      let upd={
        gatewayId:this.gateway.gatewayId,
        gmbDeviceTypes:devTypes,

      }
//       cl(upd)// gatewayId and an array of types
      await wsTrans("usa", {cmd: "cRest", uri: "/s/gateways",
        method: "update",sessionId: globs.userData.session.sessionId, body: upd
      })
    }
    this.setState({newDeviceTypes:devTypes})// until we save xBoards
//     cl(devTypes)
    return isChange
  }

  sendDeviceType=(arr,type,idx)=>{
//     cl(`send device type ${type}`)
    let st=this.state
    let typeMult=pInd[1900].pearl_gmb_types[2]
    arr.push(({
      z: +this.zone.siteZoneIndex,
      c: 240,
      i: this.ids.gmtName+typeMult*idx,
      f:2,
      t: Math.floor(getTime()),
      d: st.deviceTypes[type]?.pName,
//       d: st.contDevTypes[type],
    }));
//     cl(arr)
  }

  sendOneDeviceReg=(arr,r,regMult,regIds,regIdx,idx)=>{
    Object.keys(regIds).forEach(id=>{
//       cl(id)
      let val=(id=="type")?
        (idx&0x0F)|(r.regCnt<<4):// double duty, now
        r[id]// use the local type
//       if(id=="type"){
//         cl(val)
//         cl(r)
//       }
      if(["ofs","slope"].includes(id)){
//         cl(r)
//         cl(val)
        val=this.floatTo16Conv(val)
//         cl(id, val)
      }
      arr.push(({
        z: +this.zone.siteZoneIndex,
        c: 240,
        i: regIds[id]+regIdx.idx*regMult,
        f:2,
        t: Math.floor(getTime()),
        d: val,
      }));
    })
    regIdx.idx++// next register slot
//     cl(arr)
  }

  sendDeviceRegs=(arr,regIdx,type,idx,regIds,regMult)=>{
// idx is local type
//     cl(this.ids)
    let st=this.state
    let registers=st.deviceTypes[type].registers
//     cl(registers)
    registers.forEach(r=>{
      this.sendOneDeviceReg(arr,r,regMult,regIds,regIdx,idx)
    })
  }

  sendEndReg=(arr,regIdx,regIds,regMult)=>{
// most important this has dataType=0, marking the end of table
    let endReg={
      addr:0,
//       regSpc:0,
//       regCnt:0,
      ofs:0,
      slope:0,
      type:0,
      flags0:0,
      dataType:0,
    }
    this.sendOneDeviceReg(arr,endReg,regMult,regIds,regIdx,0)
  }

  sendDeviceTypes=async()=>{
//     cl(this.gateway.gmbDeviceTypes)
    if(!this.gateway.gmbDeviceTypes){return}
    let arr=[]
    let regIdx={idx:0}// incremented by register
    let regMult=pInd[1900].pearl_gmb_registers[2]
    let regIds={
      addr:this.ids.gmrRegisterId,
//       regSpc:this.ids.gmrRegisterSpc,
//       regCnt:this.ids.gmrRegisterCnt,
      ofs:this.ids.gmrCalOfs,
      slope:this.ids.gmrCalSlope,
      type:this.ids.gmrType,
      flags0:this.ids.gmrFlags,
      dataType:this.ids.gmrDataType,
    }
    this.gateway.gmbDeviceTypes.forEach((t,i)=>{
//       cl(t)
      this.sendDeviceType(arr,t,i)
      this.sendDeviceRegs(arr,regIdx,t,i,regIds,regMult)
//       cl(t)
    })
    this.sendEndReg(arr,regIdx,regIds,regMult)
//     cl(arr)
    let ret=await sendArray(arr,0,1900,0,false)
//     cl(ret.result)
  }

  saveDeviceTypes=async()=>{
    await this.updateUniqueDeviceTypes()
    this.sendDeviceTypes()// always send
//     if(await this.updateUniqueDeviceTypes()){// if changed
//       this.sendDeviceTypes()
//     }
  }

  findGmbBoard=(xBoards,type,port,addr)=>{
//     for(let i=0;i<xBoards.length;i++){
//       if()
//     }

  }


  gotMbAddr=(addr)=>{
    let xBoards=this.state.xBoards
    for(let i=0;i<xBoards.length;i++){
      let xb=xBoards[i]
      if((xb?.addIndex==addr)&&(xb?.typeId!=0)){return i}
    }
    return -1
  }

  getStartingChs=()=>{
    let stInp=0
    let stOut=0
    this.state.xBoards.forEach(xb=>{
      if(xb){
        let si=+xb.startInp+ +xb.numInps
        if(stInp<si){stInp=si}
        let so=+xb.chIndex+ +xb.numOutId
        if(stOut<so){stOut=so}
      }
    })
    return[stInp,stOut]
  }

  getNumInOut=(dev)=>{
/* for each register, dig or an, add the number of ins or outs it has
 */
//     cl(dev)
    let devType=this.state.deviceTypes[dev.type]
    let numInp=0
    let numOut=0
    devType.registers.forEach(r=>{
//       cl(r)
      let digIO=[2,4,8,16][(r.flags0&c.DILN_MASK)>>c.DILN_SHIFT]
      let ioCnt=((r.flags0&c.ANDI_MASK)==c.ANDI_ANA)?1:digIO
//       cl(ioCnt)
      if((r.flags0&c.STCO_MASK)==c.STCO_STATUS){numInp+=ioCnt}
      if((r.flags0&c.STCO_MASK)==c.STCO_OUTPUT){numOut+=ioCnt}
//       cl(numInp,numOut)
//         if((r.flags0&c.ANDI_MASK)==c.ANDI_ANA){
//           numOut++
//         }else{
//           cl(r.flags0&c.DILN_MASK)
//           numOut+=(r.flags0&c.DILN_MASK)>>c.DILN_SHIFT
//         }
//       }
    })
//     cl(numInp,numOut)
    return[numInp,numOut]
  }

  findBlankXb=()=>{
    let xBoards=this.state.xBoards
    for(let i=0;i<xBoards.length;i++){
//       cl(xBoards[i])
      if(!xBoards[i]){return i}
    }
    return -1
  }

  getInstDevType=(d)=>{
    return this.state.instDeviceTypes.map((t,i)=>{
      return {ind:i,type:t}})
      .filter(t=>{return t.type==d.type})[0].ind
  }

  sendXBoard=(arr,xb,xbInd)=>{
// add to arr, and update xBoards state
// xb can be null, meaning erase - set to 0's
//     cl(`send xboard ${xbInd}`)
    xBoardIds.forEach(id=>{
      arr.push(({
        z: +this.zone.siteZoneIndex,
        c: 240,
        i: this.ids[id]+xbInd*xbMult,
        f:2,
        t: Math.floor(getTime()),
        d: (xb||{})[id]||0,
      }));
    })
    let xBoards=this.state.xBoards.slice(0)
    xBoards[xbInd]=xb
//     this.setState({xBoards:xBoards})
  }

//   addXB=(arr,d,xbInd,stInp,stOut,numInp,numOut)=>{
//     let st=this.state
//     let xBoards=st.xBoards.slice(0)
//     let instDevType=this.getInstDevType(d)
//     let xBoard={
//       addIndex:d.addr,
//       chIndex:stOut,
//       mbPort:3,
//       numInps:numInp,
//       numOutId:numOut,
//       startInp:stInp,
//       typeId:(+constant.MB_GMB_0)+instDevType,
//     }
// //     cl(xBoards[xbInd])
//     this.sendXBoard(arr,xBoard,xbInd)
// //     this.setState({xBoards:xBoards})
//   }
//
//   updXB=(arr,d,xbInd)=>{
//     let st=this.state
//     let xBoard=st.xBoards[xbInd]
// //     let xBoards=st.xBoards.slice(0)
//     let instDevType=this.getInstDevType(d)
// //     xBoards[xbInd]
//     xBoard.typeId=(+constant.MB_GMB_0)+instDevType
// //     cl(xBoard)
//     this.sendXBoard(arr,xBoard,xbInd)
// //     this.setState({xBoards:xBoards})
//
//   }

  getInpsOuts=(devices)=>{
/* and numInps and numOuts to devices*/
//   cl(devices)
    devices.forEach(d=>{
//       cl(d)
      let [numInp,numOut]=this.getNumInOut(d)
      d.numInp=numInp
      d.numOut=numOut
    })
  }

  makeInpOutMap=(xBoards)=>{
    let inpMap=Array(256)
    let outMap=Array(256)
    xBoards.forEach(xB=>{
      if(xB&&(xB.typeId!=constant.MB_SLAVE_TYPE_NONE)){
        for(let i=(+xB.startInp);i<(+xB.startInp)+(+xB.numInps);i++){
          inpMap[i]=1
        }
        for(let i=(+xB.chIndex);i<(+xB.chIndex)+(+xB.numOutId);i++){
          outMap[i]=1
        }
      }
    })
    return [inpMap,outMap]
  }

  findStartCh=(numCh,map)=>{
// find numCh of open spaces
    let lastUsed=0
    for(let i=0;i<256;i++){
      if(map[i]){
        lastUsed=i+1
      }else{
        if((i-lastUsed)>=numCh){
          return lastUsed
        }
      }
    }
  }

  updMap=(stCh,numCh,map)=>{
    for(let i=stCh;i<stCh+numCh;i++){
      map[i]=1
    }
  }

  addOneNewGmb=(xBoards,devices,inpMap,outMap,dev,idx,devTypes)=>{
// add to xBoards, and update the maps
    let type=devTypes.indexOf(dev.type)
//     cl(inpMap)
    let stIn=this.findStartCh(dev.numInp,inpMap)
//     cl(stIn)
    this.updMap(stIn,dev.numInp,inpMap)
    let stOut=this.findStartCh(dev.numOut,outMap)
    this.updMap(stOut,dev.numOut,outMap)
//     cl(type,dev)

    xBoards[idx]={
      typeId:constant.MB_GMB_0+type,
      mbPort:dev.port-1,
      addIndex:dev.addr,
      startInp:stIn,
      numInps:dev.numInp,
      chIndex:stOut,
      numOutId:dev.numOut,
    }
//     cl(xBoards[0])
//     cl(xBoards[1])
//     cl(xBoards[2])
  }

  addNewGmb=(xBoards,devices,inpMap,outMap)=>{
/* existing new devices are marked as got
look for empty xBoard entries, and holes in the inps and outs
and map the new board there*/
    let devTypes=this.getDeviceTypes()
    devices.forEach(d=>{
//       cl(d.type)
      if(!d.got){// board to add
        for(let i=0;i<xBoards.length;i++){
//           cl(xBoards[i])
          if(!xBoards[i]){// empty slot
//             cl(`add ${d.type} to ${i}`)
            this.addOneNewGmb(xBoards,devices,inpMap,outMap,d,i,devTypes)
            break
          }
        }
      }
    })
  }

  changedXBoards=(xb1,xb2)=>{
    let changed=false
    xBoardIds.forEach(id=>{
      let v1=+((xb1||{})[id]||0)
      let v2=+((xb2||{})[id]||0)
      changed|=(v1!=v2)
    })
    return changed
  }

  sendXBoards=async(xBoards)=>{
    let st=this.state
    let arr=[]
//     cl(st.xBoards)
    let len=Math.max(xBoards.length,st.xBoards.length)
    for(let i=0;i<len;i++){
      let xb=xBoards[i]
      if(xb){
        if(this.changedXBoards(xb,st.xBoards[i])){
//           cl(i,xb)
          this.sendXBoard(arr,xb,i)
        }

      }else{
        if(st.xBoards[i]){this.sendXBoard(arr,null,i)}
      }
    }
//     xBoards.forEach((xb,i)=>{
//     })
    let ret=await sendArray(arr,0,1900,0,false)
//     cl(arr)
  }

  saveXBoards=async()=>{
/* first, remove the missing gMb boards
 *
 */
    let st=this.state
//     let xBoards=[]
    let xBoards=st.xBoards.slice(0)// shallow copy
    st.xBoards.forEach((xB,i)=>{xBoards[i]=(xB)?Object.assign({},xB):null})// new obj
//     cl(xBoards)
    let devices=st.devices.slice(0)
    this.getInpsOuts(devices)// now devices has inps, outs
  // remove missing boards, and mark the ones we have
  // *and* update the local type
    this.removeMissingGmb(xBoards,devices)
    let [inpMap,outMap]=this.makeInpOutMap(xBoards)
    this.addNewGmb(xBoards,devices,inpMap,outMap)
    cl(xBoards)
    await this.sendXBoards(xBoards)
    this.setState({
      xBoards:xBoards,
      instDeviceTypes:st.newDeviceTypes,
    })
  }


//   saveXBoardsO=async()=>{
// // if the device does not exist, then add it, if it *does*, then update the gmbDeviceType
// //     cl("save xBoards")
//     let arr=[]
//     let st=this.state
//     let xBoards=st.xBoards.slice(0)
//     this.removeMissingGmb(xBoards)
//     st.devices.forEach(d=>{
// //       let xbInd=this.gotMbAddr(d.addr)
//       let xbInd=this.findGmbBoard(xBoards,d.type,d.port,d.addr)
//       cl(xbInd)
//       if(xbInd<0){// returns index of board
//         let [stInp,stOut]=this.getStartingChs()
// //         cl(stInp,stOut)
//         let [numInp,numOut]=this.getNumInOut(d)
// //         cl(numInp,numOut)
//         xbInd=this.findBlankXb()
// //         cl(xbInd)
//         if(xbInd>=0){
//           cl(`add xb: ind: ${xbInd}, type: ${d.type}, addr: ${d.addr}`)
//           this.addXB(arr,d,xbInd,stInp,stOut,numInp,numOut)
//         }
//       }else{// update devType
//         cl(`upd xb: ind: ${xbInd}, type: ${d.type}, addr: ${d.addr}`)
//         this.updXB(arr,d,xbInd)
//       }
// //       cl(d)
//     })
//     this.removeMissingGmb(arr)
//     cl(this.state.xBoards)
// //     let ret=await sendArray(arr,0,1900,0,false)
// //     cl(ret)
//
// //     cl(arr)
//   }

  removeMissingGmb=(xBoards,devices)=>{
// Scan xBoards, for each gmb, check if in devices
// if so, mark that *device* as got
// if not, remove the xBoard
    let st=this.state
    let deviceTypes=this.getDeviceTypes()// *new* types
//     cl(deviceTypes)
    devices.forEach(d=>{d.got=false})
    for(let i=0;i<xBoards.length;i++){
      let xb=xBoards[i]
//       cl(`xBoard ${i}`)
      let gmbType=(xb?.typeId||0)-constant.MB_GMB_0// local devType
      if((gmbType>=0)&&(gmbType<16)){// one of ours
        let gmbType2=st.instDeviceTypes[gmbType]// typeId
//         cl(gmbType2)
        let key=// for the device in xBoards
`${gmbType2}-${xb.mbPort+1}-${xb.addIndex}-${xb.numInps}-${xb.numOutId}`
        let got=false
        for(let j=0;j<devices.length;j++){// scan new devices
//           cl(`dev ${j}`)
          let d=devices[j]
          let key2=// for new device
`${d.type}-${d.port}-${d.addr}-${d.numInp}-${d.numOut}`
//           cl(key,key2)
          if(key==key2){// if found
//             cl("found")
            xBoards[i].typeId=
              constant.MB_GMB_0+deviceTypes.indexOf(gmbType2)// new type
            if(d.got){
              cl(`remove ${i}`)
              xBoards[i]=null
            }// already got
            d.got=true
            got=true
            break
          }
        }
        if(!got){
          xBoards.splice(i,1)
          xBoards.push(null)
          i--
//           xBoards[i]=null
        }
      }
    }
//     xBoards.forEach((xb,i)=>{
//     })
  }

//   removeMissingGmbO=(arr)=>{
// //     cl("remove missing")
//     let st=this.state
// // remove gmb boards from xBoards that don't match a current addr
//     let gotAddrs=st.devices.map(d=>{return d.addr})
// //     cl(gotAddrs)
//     this.state.xBoards.forEach((xb,i)=>{
//       let gmbType=xb.typeId-constant.MB_GMB_0
//       if((gmbType>=0)&&(gmbType<16)){
//         if(!gotAddrs.includes(+xb.addIndex)){
//           xb.typeId=0
//           this.sendXBoard(arr,xb,i)
//         }
// //         cl(xb)
//       }
//     })
//
//   }

  saveDevices=async()=>{
    let st=this.state
    await this.saveDeviceTypes()
    await this.saveXBoards()
//     let devices=st.devices.slice(0)
//     cl(devices)

  }

  saveGmbTypes=async()=>{
    cl("save types")
    let st=this.state
    let query={type:"gmbDevTypes",vals:st.deviceTypes}
    cl(query)
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/gmbConfig",
      method: "update", sessionId: globs.userData.session.sessionId,
      body: query})
  }

  streamToArray=(stream)=>{
    return this.streamFields.map(f=>stream[f])
  }

//   streamFromArray=(arr)=>{
//     let ret={}
//     this.streamFields.forEach((f,i)=>{ret[f]=arr[i]})
//     return ret
//   }

  streamFromArray = arr =>
    Object.fromEntries(this.streamFields.map((f, i) => [f, arr[i]]));

  loadStreams=()=>{
//     cl(this.zInd)
    let streams=[]
    for(let i=0;i<32;i++){
      let val=getDbVal("pearl_mb_stream","dataToSend",this.zInd,240,i)
      if(val){
        let stream={}
        this.streamFields.forEach(f=>{
          stream[f]=getDbVal("pearl_mb_stream",f,this.zInd,240,i)
        })
        streams.push(stream)
      }
    }
//     cl(streams)
    this.oldStreams=streams.map(s=>{return Object.assign({},s)})// deep copy
    return streams
//     this.setState({streams:streams})
  }

  saveStreams=async()=>{
    let st=this.state
//     cl("save streams")
//     cl(st.streams)
//     cl(this.oldStreams)
    let cnt=Math.max(this.oldStreams.length,st.streams.length)
    let now=Math.floor(getTime())
    let arr=[]
    for(let i=0;i<cnt;i++){
      let s=st.streams[i]
      if(!objEq(this.oldStreams[i],s)){
        if(!s){s=Object.fromEntries(this.streamFields.map(f=>[f,0]))
          cl(s)
        }
        let stream=Object.keys(s)
//         .filter(field=>(field!="name"))
        .map(field=>{// k is the field
          return{
            z:this.zInd,
            c:240,
            i:getDbId("pearl_mb_stream",field,i),
            f:2,
            t:now,
            d:s[field]||0,
          }
        })
        arr.push(stream)
      }
    }
//     let arr=st.streams.map((s,i)=>{
//     })
//     cl(arr)
    var ret
    if(arr.length){ret=await sendArray(arr.flat(),0,1900,0,false)}
//     cl(ret)
  }

  saveModbus=async()=>{
    let st=this.state
    switch(st.pageType){
      case "types":
        this.saveGmbTypes()
        break
      case "config":
        await this.saveDevices()
      case "stream":
        await this.saveStreams()
    }
//     cl("save modbus")
    globs.events.publish("saveOK",true)
  }

  setRegVal=(ind,val)=>{
    let regVals=this.state.regVals.slice(0)
    let val0=Math.round(val*100)/100
    if(isNaN(val0)){val0="No Response"}
    regVals[ind]=val0//Math.round(val*100)/100
    this.setState({regVals:regVals})
  }

  dmRead0=async(mbBuf,clientId,port,addr,type,reg,cnt,)=>{
    let cmd=[c.MB_RD_COIL,c.MB_RD_DISC,c.MB_RD_HOLD,c.MB_RD_INP]
      [type]
    mbBuf.addByte(addr)
    mbBuf.addByte(cmd)
    mbBuf.addReg(reg)
    mbBuf.addReg(cnt)// get 1 register
//     mbBuf.showBuf()
    let query={
      cmd:"mbRead",
      port:port,
      buf:mbBuf.getBuf(),
      clientId:clientId,
    }
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/modbusGp",
      method: "retrieve", sessionId: globs.userData.session.sessionId,
      body: query})
    return res.data
  }

  regSpecOrder=[
      [],// none
      [0,1,2,3,0],// float0123
      [2,3,0,1,0],// float
      [3,2,1,0,0],// float
      [1,0,3,2,0],// float
      [],// channel???
      [0,1,2,3,1],// int 0123
      [2,3,0,1,1],// int
      [3,2,1,0,1],// int
      [1,0,3,2,1],// int
    ]

  dmrWriteSpec=(mbBuf,spec,val)=>{
//     cl(spec,val)
    mbBuf.addReg(2)// number of registers
    mbBuf.addByte(4)// number of bytes

    let order=this.regSpecOrder[spec]
//     cl(order)
    let buf=new Buffer(4)
    switch(order[4]){
      case constant.GMB_SPEC_FLOAT:
        buf.writeFloatLE(+val,0)
//         cl(+val)
//         cl(buf)
        break
      case constant.GMB_SPEC_INT:
        buf.writeInt32LE(+val,0)
        break
    }
//     cl(buf)
    for(let i=0;i<4;i++){
      mbBuf.buf[7+i]=buf[order[i]]
    }
//     mbBuf.showBuf()
//     cl(mbBuf.buf)
  }

  dmrReadSpec=(mbBuf,spec)=>{
//     cl(mbBuf,spec)
//     let order=[
//       [],// none
//       [0,1,2,3,0],// float0123
//       [2,3,0,1,0],// float
//       [3,2,1,0,0],// float
//       [1,0,3,2,0],// float
//       [],// channel???
//       [0,1,2,3,1],// int 0123
//       [2,3,0,1,1],// int
//       [3,2,1,0,1],// int
//       [1,0,3,2,1],// int
//     ][spec]
    let order=this.regSpecOrder[spec]
    let buf=new Buffer(4)
    buf.writeFloatLE(10,0)
    for(let i=0;i<4;i++){
//       cl(3+i,)
      buf[order[i]]=mbBuf.buf[3+i]
    }
    var val
    switch(order[4]){
      case constant.GMB_SPEC_FLOAT:
        val=buf.readFloatLE(0)
        break
      case constant.GMB_SPEC_INT:
        val=buf.readInt32LE(0)
        break
    }
    return val
  }


  directMbRead=async(reg,vals)=>{
    let st=this.state
    let mbBuf=new MbBuf(6)// size of the message
    let spec=(reg.flags0&c.RESP_MASK)>>c.RESP_SHIFT
    let data=await this.dmRead0(
      mbBuf,
      st.clientId,
      st.mbPort-1,
      st.mbAddr,
      reg.flags0&c.MBTY_MASK,
      reg.addr,
      +(reg.regCnt||0)+1,// reg cnt
    )
    if(data){
      mbBuf.setBuf(data)
//       mbBuf.showBuf()
      let val=(spec)?this.dmrReadSpec(mbBuf,spec):mbBuf.getReg(3)
      this.setRegVal(vals.reg,val)
    }
  }

  readReg=async(vals)=>{
    let st=this.state
    this.setRegVal("")
    let reg=st.deviceTypes[st.devType].registers[vals.reg]
    let regVals=st.regVals.slice(0)
    regVals[vals.reg]=""
    this.setState({regVals:regVals})
    await this.directMbRead(reg,vals)
  }

  writeReg=async(vals)=>{
    let st=this.state
//     cl(vals)
    let reg=st.deviceTypes[st.devType].registers[vals.reg]
    let cmd=[c.MB_WR_COIL,c.MB_RD_DISC,c.MB_WR_HOLD,c.MB_RD_INP]
      [reg.flags0&c.MBTY_MASK]
//     cl()
    if(reg.regCnt){cmd=c.MB_WR_HOLDS}
    let mbLen=(reg.regCnt)? 9+2*reg.regCnt : 6// size of the message
    let mbBuf=new MbBuf(mbLen)// reg.regCnt=0 means 1 reg
    mbBuf.addByte(st.mbAddr)
    mbBuf.addByte(cmd)
    mbBuf.addReg(reg.addr)
//     mbBuf.addReg(st.regVals[vals.reg])// get 1 register
    if(reg.regCnt){
      let regSpc=(reg.flags0&c.RESP_MASK)>>c.RESP_SHIFT
      this.dmrWriteSpec(mbBuf,regSpc,st.regVals[vals.reg])
//       mbBuf.addRegSpec(st.regVals[vals.reg],regSpc)
    }else{
      mbBuf.addReg(st.regVals[vals.reg])// get 1 register
    }
//     cl(st.regVals[vals.reg])
//     mbBuf.showBuf()
    let query={
      cmd:"mbRead",
      port:st.mbPort-1,
      buf:mbBuf.getBuf(),
      clientId:st.clientId,
    }
//     cl(query)
//     return
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/modbusGp",
      method: "retrieve", sessionId: globs.userData.session.sessionId,
      body: query})
//     mbBuf.setBuf(res.data)
//     let regVals=st.regVals.slice(0)
//     regVals[vals.reg]=mbBuf.getReg(3)
//     this.setState({regVals:regVals})
  }

  regVal=(vals)=>{
//     cl(vals)
    let st=this.state
    let regVals=st.regVals.slice(0)
    regVals[vals.ind]=vals.val
    this.setState({regVals:regVals})
  }

  newDevice=(vals)=>{
//     cl("new device")
    globs.events.publish("savePageEnable",true)
    let st=this.state
    let devices=st.devices.slice(0)
    devices.push({
      type:Object.keys(st.deviceTypes)[0],
      addr:1,
      port:1,
    })
    this.setState({devices:devices,selDevice:devices.length-1})
  }



  deleteStream=(vals)=>{
    let st=this.state
    cl("delete stream")
    if(st.selStream<0){return}
    globs.events.publish("savePageEnable",true)
    let streams=st.streams.slice(0)
    streams.splice(st.selStream,1)
    let selStream=streams.length-1
    if(selStream<0){selStream=-1}
    this.setState({streams:streams,selStream:selStream})
  }

  newStream=(vals)=>{
    globs.events.publish("savePageEnable",true)
    let st=this.state
    let streams=st.streams.slice(0)
    streams.push({
      name:`Stream ${st.streams.length+1}`,
      type:0,
      id:0,
      port:3,
      addr:0,
      reg:0,
      mbFunc:6,
      format:0,
      period:60,
      ofs:0,
      slope:1,
    })
    this.setState({streams:streams,selStream:streams.length-1})
  }



  deleteDevice=(vals)=>{
    cl("delete device")
    globs.events.publish("savePageEnable",true)
    let st=this.state
    let devices=st.devices.slice(0)
    devices.splice(st.selDevice,1)
    this.setState({devices:devices,selDevice:devices.length-1})
  }

  newCfgType=async(vals)=>{
    cl("newCfgType")
    globs.events.publish("savePageEnable",true)
    let st=this.state
    let deviceTypes=Object.assign(st.deviceTypes)
    let id=await getRandomString(8)
    deviceTypes[id]={
      name:`New Type ${st.newTypeId}`,
      registers:[]
    }
    this.setState({deviceTypes:deviceTypes,cfgType:id,
      newTypeId:st.newTypeId+1
    })
  }

  delCfgType=(vals)=>{
    cl("delCfgType")
    globs.events.publish("savePageEnable",true)
    let st=this.state
    let deviceTypes=Object.assign(st.deviceTypes)
    delete deviceTypes[st.cfgType]
    let cfgType=Object.keys(deviceTypes)[0]||""
    this.setState({deviceTypes:deviceTypes,cfgType:cfgType})
  }

  newCfgReg=(vals)=>{
    cl("newCfgType")
    globs.events.publish("savePageEnable",true)
    let st=this.state
    let deviceTypes=Object.assign(st.deviceTypes)
    let regs=deviceTypes[st.cfgType].registers
    regs.push({
      name:`New Register ${st.newRegId}`,
      addr:0x0001,
      ofs:0,
      slope:1.0,
      flags0:c.MBTY_INP|c.STCO_STATUS|c.ANDI_ANA|c.PRIO_0,
      dataType:c.GMB_DATA_TYPE_NONE,
    })
    this.setState({deviceTypes:deviceTypes,cfgReg:regs.length-1,
      newRegId:st.newRegId+1
    })
  }

  delCfgReg=(vals)=>{
    cl("delCfgReg")
    globs.events.publish("savePageEnable",true)
    let st=this.state
    let deviceTypes=Object.assign(st.deviceTypes)
    let regs=deviceTypes[st.cfgType].registers
    regs.splice(st.cfgReg,1)
    this.setState({deviceTypes:deviceTypes,cfgReg:0})
  }

  regUp=()=>{
    cl("reg up")
    let st=this.state
    let deviceTypes=Object.assign(st.deviceTypes)
    let regs=deviceTypes[st.cfgType].registers
    let regId=st.cfgReg
    if(!regId){return}// at top
    let reg=regs.splice(regId,1)[0]
    regs.splice(regId-1,0,reg)
    this.setState({deviceTypes:deviceTypes,cfgReg:regId-1})
  }

  regDn=()=>{
    cl("reg dn")
    let st=this.state
    let deviceTypes=Object.assign(st.deviceTypes)
    let regs=deviceTypes[st.cfgType].registers
    let regId=+st.cfgReg
    if(regId>=regs.length-1){return}// at bottom
//     if(!regId){return}// at top
    let reg=regs.splice(regId,1)[0]
    cl(regs)
    cl(regId)
    regs.splice(regId+1,0,reg)
    cl(regs)
    this.setState({deviceTypes:deviceTypes,cfgReg:regId+1})
  }

  setCfgTypeName=(vals)=>{
    let st=this.state
    let deviceTypes=Object.assign({},st.deviceTypes)
    Object.assign(deviceTypes[st.cfgType],vals)
//     deviceTypes[st.cfgType].name=vals.name
    this.setState({deviceTypes:deviceTypes})
  }

//   setCfgRegName=(vals)=>{
//     let st=this.state
//     let registers=st.deviceTypes[st.cfgType].registers.slice(0)
//     cl(registers)
//     registers[st.cfgReg||0].name=vals.name
//     let deviceTypes=Object.assign({},st.deviceTypes)
//     deviceTypes[st.cfgType].registers=registers
// //     deviceTypes[st.cfgType].name=vals.name
//     this.setState({deviceTypes:deviceTypes})
//   }

  setCfgRegVal=(type,vals)=>{
    let st=this.state
    let deviceTypes=Object.assign({},st.deviceTypes)
    let reg=deviceTypes[st.cfgType].registers[st.cfgReg||0]
    if(type=="cfgRegVal"){
      Object.assign(reg,vals)
    }else{
      reg.flags0=(reg.flags0&~vals.mask)|(vals[type]<<vals.shift)
//       cl(reg.flags0)
    }
    this.setState({deviceTypes:deviceTypes})
  }

  setStrVals=(vals)=>{
    let st=this.state
    let streams=st.streams.slice(0)
    let stream=streams[st.selStream]
    if(vals.type!=null){vals.format=0}
    if(vals.dataToSend!=null){vals.id=0}
    Object.assign(stream,vals)
    cl(stream)
    this.setState({streams:streams})
  }

  onChange=(type,vals)=>{
//     cl(type,vals)
    let st=this.state
    let cmds={regVal:this.regVal,readReg:this.readReg,
      writeReg:this.writeReg,newDevice:this.newDevice,
      deleteDevice:this.deleteDevice,newCfgType:this.newCfgType,
      delCfgType:this.delCfgType,newCfgReg:this.newCfgReg,
      delCfgReg:this.delCfgReg,regUp:this.regUp,regDn:this.regDn,
      newStream:this.newStream,deleteStream:this.deleteStream,
      selStream:this.selStream,
    }
    if(cmds[type]){return cmds[type](vals)}
    switch(type){
      case "setState":
        this.setState(vals)
        break
      case "pageType":
//         cl(vals)
        if(vals.pageType=="types"){
          vals.cfgType=Object.keys(st.deviceTypes)[0]
//           cl(vals)
        }
        this.setState(vals)
        break
//       case "readReg":
//         cl(vals)
//         break
//       case "writeReg":
//         cl(vals)
//         break
      case "regVal":
        cl(vals)
        break
      case "devTypeDirect":
        vals.regVals=[]
        this.setState(vals)
        break
      case "mbAddr":
      case "mbPort":
      case "devType":
        globs.events.publish("savePageEnable",true)
        let devices=st.devices.slice(0)
        Object.assign(devices[st.selDevice],vals)
//         cl(vals)
//         cl(devices)
        this.setState({devices:devices})
        break
      case "cfgType":
      case "cfgPearl":
        globs.events.publish("savePageEnable",true)
        this.setCfgTypeName(vals)
        break
      case "strVals":
        globs.events.publish("savePageEnable",true)
        this.setStrVals(vals)
        break
      case "cfgRegVal":
//         this.setCfgRegVal(type,vals)
//         break
      case "mbFlagType":
      case "mbFlagStCo":
      case "mbFlagAnDi":
      case "mbFlagPrio":
      case "mbFlagDiLn":
      case "mbFlagReSp":
//       case "mbFlagReCnt":
        globs.events.publish("savePageEnable",true)
        this.setCfgRegVal(type,vals)
//         cl(vals)
        break
      default:
//         cl(vals)
        this.setState(vals)
        break
    }
  }

  showDeviceTypeSelect=()=>{
    let st=this.state
//     let opts=[
//       {v:"xy-md02",t:"XY-MD02"},
//     ]
    let opts=Object.keys(st.deviceTypes).map(d=>{
      return({v:d,t:st.deviceTypes[d].name})
    })
    return(
      <C18Select01 parms={{
        label:"Select DeviceType",
        valueName:"devType",
        devType:(st.devType||0),
        opts:opts,
        onChange:(e,v)=>{this.onChange("devTypeDirect",v)}//this.onChange,
      }}/>
    )
  }

  streamTypes=[
    {v:c.STYPE_NONE,t:"Select a Type"},
    {v:c.STYPE_SENSOR,t:"Sensor"},
    {v:c.STYPE_EQ_POS,t:"Eq Pos"},
    {v:c.STYPE_SETPOINT,t:"Setpoint"},
    {v:c.STYPE_STAGE,t:"Stage"},
    {v:c.STYPE_AUX_VAR,t:"Aux Var"},
    {v:c.STYPE_AUX_PVAR,t:"Aux PVar"},
    {v:c.STYPE_AUX_ALARM,t:"Aux Alarm"},
    {v:c.STYPE_NUMBER,t:"Number"},
  ]

  showStreamSelect=(label,name,opts)=>{
    let st=this.state
//     cl(name,opts)
//     cl(opts)
    let stream=st.streams[st.selStream]// handling format case
//     let raw=stream?.[name]||0
    let val=stream?.[name]
//     if(name=="format"){
//       cl(`set val to ${val}`)
//       cl(stream)
//     }
    return(
      <C18Select01 parms={{
        label:label,
        valueName:name,
        [name]:val,//st.streams[st.selStream]?.[name]||0,
           opts:opts,
           onChange:(e,v)=>{this.onChange("strVals",v)}//this.onChange,
      }}/>
    )
  }

//   showTypeSelect=()=>{
//     this.showStreamSelect("Select Type","type",this.streamTypes)
// //     let st=this.state
// //     cl(st.type)
// //     return(
// //       <C18Select01 parms={{
// //         label:"Select Type",
// //         valueName:"type",
// //         type:(st.streams[st.selStream]?.type||0),
// //            opts:this.streamTypes,
// //            onChange:(e,v)=>{this.onChange("strVals",v)}//this.onChange,
// //       }}/>
// //     )
//   }
//
//   showIdSelect=()=>{
//     let st=this.state
//     cl(st.id)
//     return(
//       <C18Select01 parms={{
//         label:"Select Id",
//         valueName:"strId",
//         strId:(st.streams[st.selStream]?.strId||0),
//            opts:this.streamTypes,
//            onChange:(e,v)=>{this.onChange("strVals",v)}//this.onChange,
//       }}/>
//     )
//   }
//
//   showConvSelect=()=>{
//     let st=this.state
//     cl(st.id)
//     return(
//       <C18Select01 parms={{
//         label:"Select Conversion",
//         valueName:"strConv",
//         strConv:(st.streams[st.selStream]?.strConv||0),
//            opts:this.streamTypes,
//            onChange:(e,v)=>{this.onChange("strVals",v)}//this.onChange,
//       }}/>
//     )
//   }
//
  showPort=()=>{
    let st=this.state
    let opts=[1,2,3,4,5].map(p=>{return{v:p,t:p}})
    return(
      <C18Select01 parms={{
        label:"MB Port",
        valueName:"mbPort",
        mbPort:(st.mbPort||0),
        opts:opts,
        onChange:(e,v)=>{this.onChange("setState",v)}//this.onChange,
      }}/>
    )
  }

  showMbAddr=()=>{
    let st=this.state
    return(
      <>
        <label htmlFor="mbAddr">Enter MB Addr</label>
        <input id="mbAddr" type="text"
          value={st.mbAddr}
          onChange={e=>{this.onChange("setState",{mbAddr:e.target.value})}}
        />
      </>
    )
  }

  showReg=(reg,i)=>{
//     cl(reg)
    let st=this.state
    let val=(reg.flags0&c.STCO_MASK)
    let isWrite=(val==c.STCO_CONFIG)||(val==c.STCO_OUTPUT)
    let inDisable=!(reg.flags0&c.STCO_CONFIG)
//     cl(inDisable)
    return(
      <React.Fragment key={i}>
        <br/>
        <div style={{width:60,display:"inline-block",
          fontSize:18,fontWeight:700,textAlign:"right",
          marginRight:10,
        }}>
          {reg.addr}
        </div>
        <div style={{width:150,display:"inline-block",
          fontSize:18,fontWeight:700}}>
          {reg.name}
        </div>
        <C18Button00 style={{marginRight:10}}
        type="button" className="filled"
          onClick={e=>{this.onChange("readReg",{reg:i})}}
        >Read</C18Button00>
        <input disabled={inDisable}
          style={{display:"inline-block",minWidth:75,}}
          id="mbAddr" type="text"
          value={(st.regVals[i]==null)?"":st.regVals[i]}
          onChange={e=>{this.onChange("regVal",
            {val:e.target.value,ind:i})}}
        />
        {isWrite&&
          <C18Button00 type="button" className="filled"
            onClick={e=>{this.onChange("writeReg",{reg:i})}}
          >Write</C18Button00>
        }<br/>
      </React.Fragment>

    )
  }

  showRegisters=()=>{
    let st=this.state
//     cl(this.devTypes)
//     cl(st.devType)
    let rows=st.deviceTypes[st.devType].registers.map((reg,i)=>{
      return this.showReg(reg,i)
    })
    return rows
  }

  showSubMenu=()=>{
    let items=[
          {v:"config",t:"Configure"},
          {v:"direct",t:"Direct"},
          {v:"types",t:"Types"},
        ]
    if(acctFeature("mbStreams")){items.push({v:"stream",t:"Stream"})}
    return(
      <C18SubMenuHeader00 parms={{
        items:items,
        pageType: this.state.pageType,
        onChange: o=>this.onChange("pageType",o),
      }}/>
    )
  }

  showConfigButs=(newCmd,delCmd,upDn)=>{
    return(<div>
      <C18Button00 style={{marginRight:10}}
      type="button" className="filled"
        onClick={e=>{this.onChange(newCmd)}}
      >New</C18Button00>
      <C18Button00 style={{marginRight:10}}
      type="button" className="filled"
        onClick={e=>{this.onChange(delCmd)}}
      >Delete</C18Button00>
      {upDn&&
        <>
        <C18Button00 style={{marginRight:10}}
        type="button" className="filled"
          onClick={e=>{this.onChange("regUp")}}
        >Up</C18Button00>
        <C18Button00 style={{marginRight:10}}
        type="button" className="filled"
          onClick={e=>{this.onChange("regDn")}}
        >Down</C18Button00>
        </>
      }
      <br/>
      </div>)
  }

  showGmbList=()=>{
    let st=this.state
//     cl(st.deviceTypes)
//     cl(st.devices)
    let rows=st.devices.map((d,i)=>{
      let type=st.deviceTypes[d.type]?.name
      let bgColor=(i==st.selDevice)?"#C0E0FF":"white"
      return(
        <tr key={i} style={{backgroundColor:bgColor,cursor:"pointer"}}
          onClick={e=>this.onChange("selDevice",{selDevice:i})}
        ><td>{d.port}
        </td><td>{d.addr}
        </td><td>{type}
        </td></tr>
      )
    })
    rows.unshift(
      <tr key="head"><th>Port</th><th>Addr</th><th>Type</th></tr>
    )
    return(
      <div style={{height:100,width:"initial",border:"1px solid black",
        borderRadius:10,padding:10,display:"inline-block",
        overflowY:"auto"
      }}>
        <table style={{width:"initial"}}><tbody>
        {rows}
        </tbody></table>
      </div>
    )
  }

  getTypeName=(type)=>{
    return this.streamTypes[type||0]?.t||""
  }

  getIdName=(type,id)=>{
//     cl(this.streamIds[type])
//     cl(id)

    return (type==c.STYPE_NUMBER)?
      id:
      (this.streamIds[type]||[]).filter(el=>{return el.v==id})[0]?.t||""
//     let val=this.streamIds[type].filter(el=>{return el.v==id})
//     cl(val[0])
//     return val[0].t
  }

  getPeriod=(period)=>{
    return this.streamPeriods.filter(p=>(p.v==period))[0].t
  }

  showStreamList=()=>{
    let st=this.state
    let style={padding:"0px 10px 0px 10px",textAlign:"center"}
//     cl(st.streams)
    //     cl(st.deviceTypes)
    //     cl(st.devices)
    let rows=st.streams.map((s,i)=>{
//       let type=st.deviceTypes[d.type]?.name
      let bgColor=(i==st.selStream)?"#C0E0FF":"white"
      return(
        <tr key={i} style={{backgroundColor:bgColor,cursor:"pointer"}}
        onClick={e=>this.onChange("selStream",{selStream:i})}
        ><td style={style}>{s.name}
        </td><td style={style}>{this.getTypeName(s.dataToSend)}
        </td><td style={style}>{this.getIdName(s.dataToSend,s.id)}
        </td><td style={style}>{s.port+1}
        </td><td style={style}>{+s.addr}
        </td><td style={style}>{+s.reg||0}
        </td><td style={style}>{this.getPeriod(+s.period)}
        </td></tr>
      )
    })
    rows.unshift(
      <tr key="head">
      <th style={style}>Name</th>
      <th style={style}>Type</th>
      <th style={style}>Id</th>
      <th style={style}>Port</th>
      <th style={style}>Addr</th>
      <th style={style}>Reg</th>
      <th style={style}>Period</th>
      </tr>
    )
    return(
      <div style={{height:100,width:"initial",border:"1px solid black",
        borderRadius:10,padding:10,display:"inline-block",
        overflowY:"auto"
      }}>
      <table style={{width:"initial"}}><tbody>
      {rows}
      </tbody></table>
      </div>
    )
  }

  showGmbEditPort=()=>{
    let st=this.state
    let opts=[1,2,3,4,5].map(p=>{return{v:p,t:p}})
    return(
      <C18Select01 parms={{
        label:"MB Port",
        valueName:"port",
        port:(st.devices[st.selDevice].port||1),
        opts:opts,
        onChange:(e,v)=>{this.onChange("mbPort",v)}//this.onChange,
      }}/>
    )
  }

  showGmbEdit=()=>{
    let st=this.state
    let opts=Object.keys(st.deviceTypes).map(k=>{

      return{v:k,t:st.deviceTypes[k].name}
    })
    return(
      <div>
        <C18Select01 parms={{
          label:"Select Type",
          valueName:"type",
          type:st.devices[st.selDevice].type||"0",
          opts:opts,
          onChange:(e,v)=>{
//             cl(v)
            this.onChange("devType",v)}
        }}/>
        {this.showGmbEditPort()}
        <label>MB Addr</label><br/>
        <input type="text"
        value={st.devices[st.selDevice].addr}
        onChange={e=>this.onChange("mbAddr",{addr:e.target.value})}/>
      </div>
    )
  }

//   valInp=(type, newVal, oldVal)=>{
//     if (type === "text") {return newVal}
//
//     if (type === "int") {
//       if (/^[0-9]+$/.test(newVal)) {
//         return +newVal;
//       }
//       return oldVal;
//     }
//
//     if (type === "float") {
//       if (/^(?:[0-9]+(?:\.[0-9]*)?|\.[0-9]+)$/.test(newVal)) {
//         return +newVal;
//       }
//       return oldVal;
//     }
//     return oldVal;
//   }

  showScrEditVal=(type,title,id)=>{
    let st=this.state
    let val=st.streams[st.selStream][id]
    if(val==null){val=""}
    return(
      <div>
      <label>{title}</label>
      <input type="text"
      value={val}
      onChange={e=>this.onChange("strVals",{[id]:valInp(type,e.target.value,val)})}/>
      <div style={{height:20}}/>
      </div>
    )
  }

  showScreenEdit=()=>{
    let st=this.state
    if(st.selStream<0){return}
//     let opts=Object.keys(st.streams).map(k=>{
//       return{v:k,t:st.streams[k].name}
//     })
//     cl(st.type)
//     cl(st.streams)
    let type=st.streams[st.selStream].dataToSend
//     let dataType=st.streams[st.selStream].type
    let formats=(st.streams[st.selStream].type<2)?// if 16 bit
      this.streamByteOrder16:
      this.streamByteOrder32
//     cl(type)
    return(
      <div>
        {this.showScrEditVal("text","Name","name")}
        {this.showStreamSelect("Select Type","dataToSend",this.streamTypes)}
        {(type==c.STYPE_NUMBER)?
            this.showScrEditVal("int","Select Id","id"):
            this.showStreamSelect("Select Id","id",this.streamIds[type]||[])
        }
        {this.showStreamSelect("Modbus Port","port",this.streamPorts)}
        {this.showScrEditVal("int","Modbus Addr","addr")}
        {this.showScrEditVal("int","Modbus Register","reg")}
        {this.showStreamSelect("Select Modbus Write","mbFunc",this.streamFuncs)}
        {this.showStreamSelect("Select Register Data Type","type", this.streamDataTypes)}
        {this.showStreamSelect("Select Register Byte Order", "format", formats)}
        {this.showScrEditVal("float","Offset","ofs")}
        {this.showScrEditVal("float","Slope","slope")}
        {this.showStreamSelect("Select Period","period",this.streamPeriods)}
        </div>
    )
  }


  showMbgDevTypeSelect=()=>{
    let st=this.state
    let opts=Object.keys(st.deviceTypes).map(t=>{
      let info=st.deviceTypes[t]
      return({v:t,t:info.name})
    })
//     cl(st.cfgType)
    return(
      <div>
      <C18Select01 parms={{
        label:"Select DeviceType",
        valueName:"cfgType",
        cfgType:(st.cfgType||0),
        opts:opts,
        onChange:(e,v)=>{
          v.cfgReg=0
          this.onChange("setState",v)}//this.onChange,
      }}/>
      {this.showConfigButs("newCfgType","delCfgType")}<br/>
      <label>Type Name</label>
      <input type="text"
      value={st.deviceTypes[st.cfgType].name}
      onChange={e=>this.onChange("cfgType",{name:e.target.value})}/>
      <label>Pearl ID</label>
      <input type="text"
      value={st.deviceTypes[st.cfgType].pName||""}
      onChange={e=>this.onChange("cfgPearl",{pName:e.target.value})}/>
      </div>
    )
  }

//   showMbgDevRegAddr=()=>{
//     let st=this.state
//     let reg=st.deviceTypes[st.cfgType].registers[st.cfgReg||0]
//     cl(reg)
//     return(
//       <div>
//       <label>Register Address</label>
//       <input type="text"
//       value={reg.addr}
//       onChange={e=>this.onChange("cfgRegVal",{addr:e.target.value})}/>
//       register addr
//       </div>
//     )
//   }

  checkValRange=(val,min,max)=>{
    if(val==0){return 0}
    let isNeg=val<0
    if(isNeg){
      min=0-min
      max=0-max
    }
    if(isNeg^(val>max)){val=max}
    if(isNeg^(val<min)){val=min}
    return val
  }

//   testValRange=()=>{
//     cl(this.checkValRange(5,.000031,131000))
//     cl(this.checkValRange(200000,.000031,131000))
//     cl(this.checkValRange(.00002,.000031,131000))
//     cl(this.checkValRange(-5,.000031,131000))
//     cl(this.checkValRange(-200000,.000031,131000))
//     cl(this.checkValRange(-.00002,.000031,131000))
//   }

  floatTo16Conv=(val)=>{
    val=this.checkValRange(val,.000031,131000)
    var buf=new Buffer(4)
    buf.writeFloatLE(val,0)
    let hex=buf.readInt32LE(0)>>>0
//     cl(hex)
    let sign=(hex&0x80000000)>>>16
    let exp=((hex&0x7F800000)>>>13)
    if(exp){exp-=(112<<10)}
    let mant=(hex&0x007FFFFF)>>>13
    return(sign|exp|mant)&0x0FFFF
  }

//   floatFrom16Conv=(reg,id)=>{
//     let val=reg[id]
//     if(["ofs","slope"].includes(id)){
//       var buf=new Buffer(4)
//       let hex=val>>>0
//       let sign=(hex&0x08000)<<16
//       let exp=((hex&0x07C00)+(112<<10))<<13
//       let mant=(hex&0x03FF)<<13
// //       let f32=sign|exp|mant
//       buf.writeInt32LE(sign|exp|mant,0)
//       val=buf.readFloatLE(0)
//     }
//     return val
//   }

//   testFloat16=()=>{
//     cl("test float16")
//     let reg={ofs:1.2e5}
//     let val=this.floatTo16Conv(reg,"ofs")
//     reg.ofs=val
//     let val2=this.floatFrom16Conv(reg,"ofs")
//     reg.ofs=26829 // 2458 = .6 * 4096 - offset
//     val2=this.floatFrom16Conv(reg,"ofs")
//     reg.ofs=17432// 4.09375 - scale
//     val2=this.floatFrom16Conv(reg,"ofs")
//   }

  showMbgDevSel=(label,id)=>{
    let st=this.state
    var opts
    switch(id){
      case "regCnt":
          opts=[...Array(16).keys()].map(k=>{
            return({v:k,t:k+1})
          })
        break
//       case "regSpc":
//         opts=[
//           {v:constant.GMB_REGSPC_NONE,t:"None"},
//           {v:constant.GMB_REGSPC_FLOAT_0123,t:"Float 0123"},
//           {v:constant.GMB_REGSPC_FLOAT_2301,t:"Float 2301"},
//           {v:constant.GMB_REGSPC_FLOAT_3210,t:"Float 3210"},
//           {v:constant.GMB_REGSPC_FLOAT_1032,t:"Float 1032"},
//           {v:constant.GMB_REGSPC_CHANNEL,t:"Channel"},
//         ]
//         break
    }
//     cl(opts)
    let reg=st.deviceTypes[st.cfgType].registers[st.cfgReg||0]
    if(!reg){return}
    let parms={
        label:label,
        valueName:id,
        opts:opts,
        onChange:(e,v)=>{this.onChange("cfgRegVal",v)}//this.onChange,
      }
      parms[id]=(reg[id]||0)
    return(
      <C18Select01 parms={parms}/>
    )
  }

  showMbgDevVal=(label,id)=>{
//     cl(id)
    let st=this.state
    let reg=st.deviceTypes[st.cfgType].registers[st.cfgReg||0]
    if(!reg){return}
//     let val=this.floatFrom16Conv(reg,id)
//     cl(reg)
    return(
      <div>
      <label>{label}</label>
      <input type="text"
      value={reg[id]}
      onChange={e=>{
        let val={}
        val[id]=e.target.value
        this.onChange("cfgRegVal",val)}}/>
      </div>
    )
  }

  showMbgDevData=()=>{
    let st=this.state
    let reg=st.deviceTypes[st.cfgType].registers[st.cfgReg||0]
//     cl(st.deviceTypes[st.cfgType])
    if(!reg){return}
//     cl(reg)
//     let types=[
//       "None",
//       "Temperature",
//       "Humidity",
//       "CO2",
//       "Light",
//       "Pressure",
//       "Moisture",
//       "Dissolved Oxygen",
//       "Distance",
//       "Flow Rate",
//       "Wind Speed",
//       "Wind Direction",
//       "pH",
//       "EC",
//       "Mass",
//       "Volume",
//     ]
// below, +1 is to avoid the "none" datatype
    let opts=st.dataTypes.slice(1).map((t,i)=>{return {v:i+1,t:t}})
    return(
      <C18Select01 parms={{
        label:"DataType",
        valueName:"dataType",
        dataType:(reg.dataType||0),
        opts:opts,
        onChange:(e,v)=>{this.onChange("cfgRegVal",v)}//this.onChange,
      }}/>
    )
  }

//   showMbgDevMbType=()=>{
//     let st=this.state
//     let reg=st.deviceTypes[st.cfgType].registers[st.cfgReg||0]
//     let types=["Coil","Discrete","Holding","Input"]
//     let opts=types.map((t,i)=>{return {v:i,t:t}})
//     return(
//       <C18Select01 parms={{
//         label:"Select MB Type",
//         valueName:"mbFlagType",
//         mbFlagType:(reg.flags0&c.MBTY_MASK),
//         opts:opts,
//         onChange:(e,v)=>{this.onChange("cfgRegMbType",v)}//this.onChange,
//       }}/>
//     )
//   }

  showMbgDevMbFlags=(id,label,mask,shift)=>{
    let st=this.state
    let reg=st.deviceTypes[st.cfgType].registers[st.cfgReg||0]
    if(!reg){return}
    let types={
      mbFlagType:["Coil","Discrete","Holding","Input"],
      mbFlagStCo:["Status","Output","Config"],
      mbFlagAnDi:["Analog","Digital"],
      mbFlagPrio:["Priority 0","Priority 1","Priority 2","Priority 3"],
      mbFlagDiLn:[2,4,8,16],
      mbFlagReSp:["None","Float 0123","Float 2301","Float 3210",
      "Float 1032","Channel","Int 0123","Int 2301","Int 3210",
      "Int 1032",],
    }
//     let types=["Status","Output","Config"]
    let opts=types[id].map((t,i)=>{return {v:i,t:t}})
    let parms={
        label:label,
        valueName:id,
//         mbFlagStCo:(reg.flags0&c.STCO_MASK)>>c.STCO_SHIFT,
        opts:opts,
        onChange:(e,v)=>{
          v.mask=mask
          v.shift=shift
          this.onChange(id,v)}//this.onChange,
      }
      parms[id]=(reg.flags0&mask)>>shift
    return <C18Select01 parms={parms}/>
  }

  showRegisterSelect=()=>{
    let st=this.state
//     cl(st.deviceTypes[st.cfgType].registers)
    let types=["Coil","Disc","Hold","Inp"]
    let stcos=["Status","Output","Config"]
    let andis=["Ana","Dig"]
    let dilns=[2,4,8,16]
    let rows=st.deviceTypes[st.cfgType].registers.map((r,i)=>{
      let type=((r.flags0&c.MBTY_MASK)>>c.MBTY_SHIFT)
      let stco=((r.flags0&c.STCO_MASK)>>c.STCO_SHIFT)
      let andi=((r.flags0&c.ANDI_MASK)>>c.ANDI_SHIFT)
      let diln=((r.flags0&c.DILN_MASK)>>c.DILN_SHIFT)
      let dilnShow=(andi)?`${dilns[diln]} bits`:"Analog"
      let bgCol=(i==st.cfgReg)?"#C0E0FF":"white"
      let dataType=r.dataType
      return(
        <tr key={`${st.cfgType}-${r.addr}-${i}`}
          style={{cursor:"pointer",backgroundColor:bgCol}}
          onClick={e=>{this.onChange("setState",{cfgReg:i})}}
        >
          <td>{r.addr}</td>
          <td>{r.name}</td>
          <td>{types[type]}</td>
          <td>{stcos[stco]}</td>
          <td>{dilnShow}</td>
          <td>{st.dataTypes[dataType]}</td>
        </tr>
      )
    })
//     cl(rows)
    return(
      <div style={{width:"fit-content",height:200,overflowY:"auto",
        border:"1px solid black",borderRadius:10,
        padding:10,
      }}>
        <table style={{width:"initial"}}><tbody>
        <tr>
          <th>Addr</th>
          <th>Name</th>
          <th>Type</th>
          <th>St/Co</th>
          <th>Ana/Dig</th>
          <th>Data Type</th>
        </tr>
        {rows}
        </tbody></table>
      </div>
    )
  }

  showMbgDevRegisters=()=>{
    let st=this.state
    let type=st.deviceTypes[st.cfgType]
//     cl(type)
    let opts=type.registers.map((r,i)=>{
      return({v:i,t:r.name})
    })
//       {this.showMbgDevSel("Register Special","regSpc")}<br/>
//       {this.showMbgDevMbFlags("mbFlagReCnt","Register Count",
//         c.GMTY_RECN_MASK,c.GMTY_RECN_SHIFT)}
    return(
      <div>
      <h3>Registers</h3>
      {this.showRegisterSelect()}<br/>
      {this.showConfigButs("newCfgReg","delCfgReg",true)}<br/>
      {this.showMbgDevVal("Register Name","name")}<br/>
      {this.showMbgDevVal("Register Address","addr")}<br/>
      {this.showMbgDevMbFlags(
        "mbFlagReSp","Register Special",c.RESP_MASK,c.RESP_SHIFT)}
      {this.showMbgDevSel("Register Count","regCnt")}<br/>

      {this.showMbgDevVal("Register Cal Offset","ofs")}<br/>
      {this.showMbgDevVal("Register Cal Slope","slope")}<br/>
      {this.showMbgDevMbFlags(
        "mbFlagType","MB Type",c.MBTY_MASK,c.MBTY_SHIFT)}
      {this.showMbgDevMbFlags(
        "mbFlagStCo","MB Status / Config",c.STCO_MASK,c.STCO_SHIFT)}
      {this.showMbgDevMbFlags(
        "mbFlagAnDi","Analog / Digital",c.ANDI_MASK,c.ANDI_SHIFT)}
      {this.showMbgDevMbFlags(
        "mbFlagPrio","Priority",c.PRIO_MASK,c.PRIO_SHIFT)}
      {this.showMbgDevMbFlags(
        "mbFlagDiLn","Digital Bits",c.DILN_MASK,c.DILN_SHIFT)}
      {this.showMbgDevData()}
      </div>
    )
  }

  showTypesPage=()=>{
    let st=this.state
    return(
      <div>
      {this.showSubMenu()}
      <div className="clearfloat"/>
      <h3>Device Types</h3>
      {this.showMbgDevTypeSelect()}
      {this.showMbgDevRegisters()}
      </div>
    )
  }

  showConfigPage=()=>{
    let st=this.state
    return(
      <div>
      {this.showSubMenu()}
      <div className="clearfloat"/>
      <h3>Devices</h3>
      {this.showGmbList()}
      <div style={{height:20}}/>
      {this.showConfigButs("newDevice","deleteDevice")}<br/>
    {(st.selDevice>=0)&&
    this.showGmbEdit()
    }
      </div>
    )
  }

  showDirectPage=()=>{
    return(
      <div>
      {this.showSubMenu()}
      <div className="clearfloat"/>
      {this.showDeviceTypeSelect()}
      {this.showPort()}
      {this.showMbAddr()}
      {this.showRegisters()}
      </div>
    )
  }

  showStreamPage=()=>{
    return(
      <div id="ModbusGpStream">
        {this.showSubMenu()}
        <div className="clearfloat"/>
        <h3>Streams</h3>
        {this.showStreamList()}
        <div style={{height:20}}/>
        {this.showConfigButs("newStream","deleteStream")}<br/>
        {this.showScreenEdit()}
      </div>
    )
  }

  render(){
    let st=this.state
//     cl(st)
    if(st.loaded){
      switch(st.pageType){
        case "direct":
          return this.showDirectPage()
        case "config":
          return this.showConfigPage()
        case "types":
          return this.showTypesPage()
        case "stream":
          return this.showStreamPage()
      }
      return this.showPage()
//       return this.showTypes()
    }else{return<div>loading. . .</div>}
  }
}

export default C18ModbusGP01;
